module.exports = __webpack_public_path__ + "public/SiteIcons/padlock.svg?ef25af9b";